export const STEP_FLIGHT_RESULTS = 'flight-results';
export const STEP_HOTEL_RESULTS = 'hotel-results';
export const STEP_HOTEL_ROOM = 'hotel-room';
export const STEP_HOTEL_DETAILS = 'hotel-details';
export const STEP_CAR_HIRE_RESULTS = 'car-hire-results';
export const STEP_CAR_HIRE_DETAILS = 'car-hire-details';
export const STEP_BOOKING = 'booking';

export const stepUrls: { [key: string]: string[] } = {
  [STEP_FLIGHT_RESULTS]: ['/travel/flight-results'],
  [STEP_HOTEL_RESULTS]: ['/travel/hotel-results'],
  [STEP_HOTEL_ROOM]: ['/travel/hotel-results/details/:hotel_id'],
  [STEP_HOTEL_DETAILS]: ['/travel/hotel-results/details/:hotel_id', '/options/hotels/:hotel_id'],
  [STEP_CAR_HIRE_RESULTS]: ['/travel/car-hire-results'],
  [STEP_CAR_HIRE_DETAILS]: ['/travel/car-hire-results/details', '/options/car-rental/:car_id'],
  [STEP_BOOKING]: ['/booking/travel'],
};
